export type SendFailureNotice = { kind: 'bubble' } | { kind: 'toast'; message: string };

export type SendFailureTags = Record<'feature' | 'http.status_code' | 'error.code', string>;

const UNKNOWN_TAG = 'unknown';
const LEFT_PATIENT_MESSAGE =
    "A message couldn't be sent to a patient you just left. Go back to their messages to retry.";

function namedPatientMessage(name: string): string {
    return `A message couldn't be sent to ${name}. Open their messages to retry.`;
}

// Once the thread has unmounted its failed bubble is gone, so only a toast can tell staff.
export function sendFailureNotice(
    threadMounted: boolean,
    patientName: string | null
): SendFailureNotice {
    if (threadMounted) return { kind: 'bubble' };
    const name = patientName?.trim();
    return { kind: 'toast', message: name ? namedPatientMessage(name) : LEFT_PATIENT_MESSAGE };
}

function readField(error: unknown, field: 'status' | 'code'): string {
    if (typeof error !== 'object' || error === null || !(field in error)) return UNKNOWN_TAG;
    const value = (error as Record<string, unknown>)[field];
    return typeof value === 'number' || typeof value === 'string' ? String(value) : UNKNOWN_TAG;
}

// The error message can echo backend text, so only status and code ever reach error tracking.
export function sendFailureTags(error: unknown): SendFailureTags {
    return {
        feature: 'dm-send',
        'http.status_code': readField(error, 'status'),
        'error.code': readField(error, 'code')
    };
}
